export const getDashboardUrl = () => {
  const isDemo = window.location.hostname.includes('demodbi360');
  return isDemo
    ? 'https://app.demodbi360.com/dashboard'
    : 'https://app.dbi360.com/dashboard';
};

export const redirectToDashboard = () => {
  window.location.href = getDashboardUrl();
};

export const getAccessTokenOrRedirect = (
  cookieGetter: (name: string) => string | undefined
) => {
  const tokenValue =
    cookieGetter('accessToken') || cookieGetter('access_token');

  if (!tokenValue) {
    redirectToDashboard();
    throw new Error('Access token not found');
  }

  return tokenValue;
};
